<script lang="ts">
  import { Button, Card, Col, Container, Row } from "sveltestrap"
  import Trade from "../components/Trade.svelte"
  import Stat from "../components/Stat.svelte"
  import Image from "../components/Image.svelte"
  import { currentChainId, pairDetail } from "../stores/store"
  import { getPairDetail } from "../stores/query"
  import { query } from "@urql/svelte"
  import {
    shortenAddress,
    encodeDescriptionHash,
    convertPairData, accountLink, nftCollectionLink, nftDetailLink,
  } from "../utils/utils"
  import ShareModal from "../components/ShareModal.svelte"
  import Clipboard from "svelte-clipboard"
  import { CHAIN_NAMES } from "../stores/constants"
  import { onMount } from "svelte"
  import { selectedAccount } from "svelte-web3"
  import DelistModal from "../components/DelistModal.svelte"

  export let id: string;
  let description: string = '';
  let shareModalOpen = false;
  let link: string;
  let y;

  let container;

  let jasonDetail: object = {};

  // $getPairDetail.variables.metaNftId = id;
  // query(getPairDetail);
  console.log(window.history);
  const shareModalToggle = () => {
    shareModalOpen = !shareModalOpen;
  }

  onMount(() => {
    y = 0;
  })

  const pairFromHistory = !!window.history.state && !!window.history.state.pair ? window.history.state.pair : {};
  getPairDetail.variables.metaNftId = id;
  query(getPairDetail);

  $: {
    try {
      if (!$getPairDetail.fetching) {
        convertPairData($currentChainId, $getPairDetail.data.pair)
          .then(convertedPairData => {
            jasonDetail = Object.assign({}, $getPairDetail.data.pair, convertedPairData);
          });
        fetch(`https://cloudflare-ipfs.com/ipfs/${encodeDescriptionHash($getPairDetail.data.pair.descriptionHash)}`)
          .then(res => res.text())
          .then(res => description = res);
      }
    } catch (e) {
      console.error(e);
    }
  }

  $: {
    link = `${window.location.protocol}//${window.location.host}/nft/${jasonDetail.id}?chain=${CHAIN_NAMES[$currentChainId]}`;
  }
</script>

<Container bind:this={container}>
  <Row class="nft-detail-margin gx-0">
    <Col>
      <a href="javascript:window.history.back();">
        <img class="icon-large" src="/icons/arrow-left.svg" alt="placeholder"/>
      </a>
    </Col>
    <Col class="text-end">
      <Clipboard
        text={link}
        let:copy
      >
        <Button class="nft-detail-button nft-detail-share" on:click={() => {copy(); shareModalToggle();}}>
          <img class="icon-small" src="/icons/share.svg" alt="placeholder"/>
          Share
        </Button>
      </Clipboard>
      <ShareModal link={link} isOpen={shareModalOpen} toggle={shareModalToggle}/>
    </Col>
    {#if (!$getPairDetail.fetching && Object.keys(jasonDetail).length !== 0) && $selectedAccount !== undefined ? jasonDetail.owner.id.toLowerCase() === $selectedAccount.toLowerCase() : false}
      <Col class="text-end col-auto">
        <DelistModal metaNftId={jasonDetail.id} denominator={jasonDetail.denominator}/>
      </Col>
    {/if}
  </Row>
  <Row class="justify-content-between nft-detail-header" cols={{ xs: 1, sm: 2 }}>
    <Col>
      <div class="nft-detail-title">{pairFromHistory.title || jasonDetail.title || ''}</div>
    </Col>
  </Row>
  <Row class="justify-content-center">
    <Col lg="4">
      <Image src={pairFromHistory.imageUrl || jasonDetail.imageUrl}/>
    </Col>
  </Row>
  <br />
  <br />
  <br />
  <Row>
    <Col xs="12" lg="6" class="order-sm-last">
      <Trade/>
    </Col>
    <Col xs="12" lg="6" class="text-start order-sm-first">
      <dl class="row nft-detail-info">
        <dt class="col-12 nft-detail-subtitle">Description</dt>
        <dd class="col-12 nft-detail-content">
          {description}
        </dd>
        <dt class="col-6 nft-detail-subtitle">Collection</dt>
        <dd class="col-12 nft-detail-content">
          <a href={nftDetailLink(jasonDetail.nftAddress, jasonDetail.tokenId, $currentChainId)} target="_blank">
            <Button class="button-fill nft-detail-button">
              {jasonDetail.collection}
              <img class="icon-small" src="/icons/outlink.svg" alt="placeholder"/>
            </Button>
          </a>
        </dd>
        <dt class="col-12 nft-detail-subtitle">MetaNFT owner address</dt>
        <dd class="col-12 nft-detail-content">
          <Button class="button-fill nft-detail-button">
            <a class="nft-detail-link" target="_blank" href={accountLink((!$getPairDetail.fetching && Object.keys(jasonDetail).length !== 0) ? jasonDetail.owner.id : '', $currentChainId)}>
              {shortenAddress((!$getPairDetail.fetching && Object.keys(jasonDetail).length !== 0) ? jasonDetail.owner.id : '')}
            </a>
            <img class="icon-small" src="/icons/outlink.svg" alt="placeholder"/>
          </Button>
        <dt class="col-12 nft-detail-subtitle">Pair ID</dt>
        <dd class="col-12 nft-detail-content">{id}</dd>
        <dt class="col-6 nft-detail-subtitle">Status</dt>
        <dd class="col-12 nft-detail-content">
          <Button class="button-fill nft-detail-button">
            {(!$getPairDetail.fetching && Object.keys(jasonDetail).length !== 0) ? (jasonDetail.activated ? 'Active' : 'Inactive') : ''}
          </Button>
        </dd>
      </dl>
    </Col>

  </Row>
  <br />
  <br />
  <br />

  <br />
  <br />
  <br />
  <Row class="justify-content-start nft-detail-stats">
    <Col>
      Stats
    </Col>
  </Row>
  <Row>
    <Col>
      <Stat/>
    </Col>
  </Row>
  <br />
  <br />
  <br />
</Container>
<svelte:window bind:scrollY={y} />
